import { Injectable } from '@angular/core';


export type BootstrapBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export enum MediaQueryType {
  MIN_WIDTH = 'min-width',
  MAX_WIDTH = 'max-width'
}

@Injectable()
export class BootstrapService {

  private breakPoints = new Map<BootstrapBreakpoint, number>([['xs', 0], ['sm', 576], ['md', 768], ['lg', 992], ['xl', 1200]]);

  constructor() { }

  public getBreakpointBoundary(breakPointName: BootstrapBreakpoint): number {
    return this.breakPoints.get(breakPointName);
  }

  public getBreakpointMediaQueryList(breakpointName: BootstrapBreakpoint, mediaQuery: MediaQueryType): MediaQueryList {
    const boundary = this.getBreakpointBoundary(breakpointName);
    if (boundary == null) {
      throw new Error('Cannot find breakpoint boundary for breakpoint with name: ' + breakpointName);
    }
    return matchMedia('('+ mediaQuery +': ' + boundary + 'px)');
  }
}
